<div class="input-number-wrapper">
    <input type="text"
           #input
           matInput
           class="mat-input-element {{align === 'r' ? 'align-right' : ''}}"
           [class.with-arrows]="hasArrows"
           autocomplete="new-password"
           [errorStateMatcher]="errorStateMatcher"
           [placeholder]="placeholder"
           [disabled]="disabled"
           (input)="customOnInput($event)"
           (change)="customOnChange($event)"
           (focus)="onInputFocus($event)"
           (blur)="onInputBlur($event)">

    <ng-container *ngIf="hasArrows">
        <div class="inc" contentEditable="false" (click)="incrementValue($event)" (dblclick)="disableEvent($event)">
            <div class="input-number-inc" contentEditable="false"></div>
        </div>
        <div class="dec" contentEditable="false" (click)="decrementValue($event)" (dblclick)="disableEvent($event)">
            <div class="input-number-dec" contentEditable="false"></div>
        </div>
    </ng-container>
</div>
